// extracted by mini-css-extract-plugin
export default {"root":"NCoKUMzEv_BcLHWRVrPY","placeHolderShimmer":"MyyFuxHCLwDL6HHvgrbg"};